module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('div', {
    staticClass: "nav-collapse",
    staticStyle: {
      "margin-top": "5em",
      "overflow": "auto"
    },
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "leftside-navigation"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "nav-accordion"
    }
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.isActive('/dashboard')
    },
    attrs: {
      "href": "dashboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/users')
    },
    attrs: {
      "href": "users"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Users")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpros')
    },
    attrs: {
      "href": "cnpros"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNPros")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/businesses')
    },
    attrs: {
      "href": "businesses"
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _vm._v(" "), _c('span', [_vm._v("Businesses")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/contracts')
    },
    attrs: {
      "href": "contracts"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Contracts")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnsurveys')
    },
    attrs: {
      "href": "cnsurveys"
    }
  }, [_c('i', {
    staticClass: "fa fa-crosshairs"
  }), _vm._v(" "), _c('span', [_vm._v("CNsurveys")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/forums')
    },
    attrs: {
      "href": "forums"
    }
  }, [_c('i', {
    staticClass: "fa fa-meh-o"
  }), _vm._v(" "), _c('span', [_vm._v("Forums")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/referrals')
    },
    attrs: {
      "href": "referrals"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', [_vm._v("Referrals")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cwallets')
    },
    attrs: {
      "href": "cnwallets"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("CNwallets")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/rewards')
    },
    attrs: {
      "href": "rewards"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Rewards")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/payments')
    },
    attrs: {
      "href": "payments"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Payments")])])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/cnpaymentsremita')
    },
    attrs: {
      "href": "cnpayments"
    }
  }, [_c('i', {
    staticClass: "fa fa-glass"
  }), _vm._v(" "), _c('span', [_vm._v(" CNpay (Remita) ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.isActive('/login')
    },
    attrs: {
      "href": "login"
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Settings")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9059748c"}!./src/components/Sidebar/template.html
// module id = 166
// module chunks = 0